module.exports = __webpack_public_path__ + "static/media/bus-icon.6270b83f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dublin-express/bus-icon.svg
// module id = 705
// module chunks = 0